import { HttpLink, from, ApolloClient, NormalizedCacheObject, InMemoryCache } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';
import { JwtHelper } from '../../helpers/jtw.helper';
import { AuthApollo } from './auth.apollo';

class ApolloLinks {
  private production = process.env.NODE_ENV === 'production';
  private uri = this.production ? undefined : process.env.REACT_APP_GRAPHQL_ENDPOINT;
  private auth_client: ApolloClient<NormalizedCacheObject>;

  constructor(private token: string, private refresh_token: string) {
    this.auth_client = new ApolloClient({
      link: this.http_link(),
      cache: new InMemoryCache(),
      defaultOptions: {
        watchQuery: {
          fetchPolicy: 'network-only',
        },
      },
    });
  }

  http_link() {
    return new HttpLink({
      uri: this.production ? '/graphql' : this.uri,
      credentials: 'same-origin',
    });
  }

  auth_link() {
    const auth_apollo = new AuthApollo(this.auth_client, this.refresh_token);

    return setContext(async (request, { headers }) => {
      if (!JwtHelper.is_valid(this.token) && this.refresh_token) {
        const data = await auth_apollo.get_new_token();

        if (data) {
          this.token = data.token;
          this.refresh_token = data.refresh_token;
        }
      }

      return {
        headers: {
          ...headers,
          'x-access-token': this.token,
        },
      };
    });
  }

  error_link() {
    return onError(({ graphQLErrors, networkError }) => {
      if (graphQLErrors) {
        for (const err of graphQLErrors) {
          if (err.extensions?.code === 'UNAUTHENTICATED') {
            alert(err.message);
            window.location.href = '/autenticacao/logout';
          }
        }
      }

      if (networkError) {
        console.log(`[Network error]: ${networkError}`);
      }
    });
  }

  concat() {
    return from([this.auth_link(), this.error_link(), this.http_link()]);
  }
}

export { ApolloLinks };
